import React, { useEffect } from "react";
import styles from "./SignUpSelectNextStep.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setActiveStep, userInfoSelector } from "../../stores/slices/sign-up-slice";
import { AppDispatch } from "../../stores/store";
import SignUpFormWrapper from "./wrapper/SignUpFormWrapper";
import { ApplicationRoutes } from "../../routes";
import CommonRadioButton from "../../common/components/new/radio-button/CommonRadioButton";
import { GreenPower, Plugin, Store } from "../../assets/icons";
import { useForm } from "react-hook-form";
import CustomerSignUpFormWrapper from "./wrapper/CustomerSignUpFormWrapper";

type Props = {};

const SignUpSelectNextStep: React.FC<Props> = (props: Props) => {
	const dispatch = useDispatch<AppDispatch>();

	const userInfo = useSelector(userInfoSelector);

	const {
		handleSubmit,
		watch,
		setValue,
		formState: { isValid, isSubmitted },
	} = useForm<{
		selectedValue: string;
	}>({
		defaultValues: {
			selectedValue: "Visit Store",
		},
		reValidateMode: "onSubmit",
		mode: "onBlur",
	});

	const navigate = useNavigate();

	const onSubmit = () => {
		switch (watch("selectedValue")) {
			case "Visit Store":
				navigate(`/${ApplicationRoutes.STORE_FRONT}`);
				break;
			case "Generate Power Need":
				navigate(`/${ApplicationRoutes.RECOMMENDATION}`);
				break;
			case "Go to Dashboard":
				navigate(`/${ApplicationRoutes.DASHBOARD}`);
				break;
		}
	};

	const onBack = () => {
		navigate(`/${ApplicationRoutes.NEW_CUSTOMER_SIGNUP_OTP}`);
	};

	useEffect(() => {
		dispatch(setActiveStep(3));
	}, [dispatch]);

	return (
		<CustomerSignUpFormWrapper
			title={`Hello ${userInfo.firstName},`}
			subtitle="What would you love to do next?"
			onBack={onBack}
			onNext={handleSubmit(onSubmit)}
			nextButtonDisabled={isSubmitted && !isValid}
		>
			<div className={styles.listContainer}>
				<CommonRadioButton
					value={"Visit Store"}
					selectedValue={watch("selectedValue")}
					title="Visit Store"
					description="Optimize energy supply for sustainability."
					onChangeValue={(value: string) => {
						setValue("selectedValue", value);
					}}
				>
					<Store />
				</CommonRadioButton>
				<CommonRadioButton
					value={"Generate Power Need"}
					selectedValue={watch("selectedValue")}
					title="Generate Power Need"
					description="At Solar Marketplace, we believe in harnessing all."
					onChangeValue={(value: string) => {
						setValue("selectedValue", value);
					}}
				>
					<Plugin />
				</CommonRadioButton>
				<CommonRadioButton
					value={"Go to Dashboard"}
					selectedValue={watch("selectedValue")}
					title="Go to Dashboard"
					description="Navigate to the dashboard with just one click."
					onChangeValue={(value: string) => {
						setValue("selectedValue", value);
					}}
				>
					<GreenPower />
				</CommonRadioButton>
			</div>
		</CustomerSignUpFormWrapper>
	);
};

export default SignUpSelectNextStep;
